module.exports = __webpack_public_path__ + "media/images/mailer/twitter-light-3ddb327b72db6832f6d6ae0afba22975.png";